module.exports = __webpack_public_path__ + "static/media/bills-emailIcon.28b860c3.svg";